// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"caravanInsideImage_imageContainer__3tPsz","imageBase":"caravanInsideImage_imageBase__1_MkF","image":"caravanInsideImage_image__Wjxf2"};